module.exports = __webpack_public_path__ + "5a43151e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4k-1280.mp4
// module id = 1210
// module chunks = 1 3 4